import React, { useEffect, useState } from 'react'

import {
  DateString,
  OrderExtendedDetails
} from '../../../../api/services/orders/types.ts'
import {
  calculateDaysBetweenDates,
  convertDateStringToFullDate,
  getCurrentDateAsString
} from '../../../../utils/dates.ts'
import { convertToShortDate } from '../../../../utils/formatter.ts'
import { realizeOrder } from '../../../../utils/handlers.ts'
import Button from '../../../common/Button/Button.tsx'
import PopupDateSelector from '../../../common/Diets/PopupDateSelector/PopupDateSelector.tsx'
import Popup from '../../../common/Popup/Popup.tsx'

type BottomButtonsProps = {
  order: OrderExtendedDetails | null
  orderID: number | undefined
  selectedFolder: number | null
  handleOnClickClose: () => void
  setChangeStatus: React.Dispatch<React.SetStateAction<boolean>>
  selectedDietID: number | null
  optionSharingSelected: 'folder' | 'diet' | null
}

const BottomButtons = (props: BottomButtonsProps) => {
  const {
    order,
    orderID,
    selectedFolder,
    handleOnClickClose,
    setChangeStatus,
    selectedDietID,
    optionSharingSelected
  } = props
  const [isPopupDateVisible, setIsPopupDateVisible] = useState(false)
  const [selectedDate, setSelectedDate] = useState<Date | null>(null)

  const fullDateCurrentDate = convertDateStringToFullDate(
    getCurrentDateAsString()
  )
  const fullDateStartDiet = convertDateStringToFullDate(
    (order?.diet_start_date ?? fullDateCurrentDate).toString()
  )

  const isStartDietForwarded =
    calculateDaysBetweenDates(fullDateCurrentDate, fullDateStartDiet) > 1

  useEffect(() => {
    if (selectedDate) {
      const selectedDateAsString = selectedDate.toString()
      const scheduleDate: DateString = convertToShortDate(
        selectedDateAsString
      ) as DateString
      const loadingToast = 'Trwa zapisywanie ...'
      const successToast = `Dieta zostanie udostępniona w aplikacji w dniu ${scheduleDate}`
      realizeOrder(
        orderID,
        selectedFolder,
        selectedDietID,
        scheduleDate,
        loadingToast,
        successToast
      )
        .then((response) => {
          if (response && response.message === 'success') {
            setChangeStatus && setChangeStatus(true)
            handleOnClickClose()
          }
        })
    }
  }, [selectedDate])

  const handleClosePopupDateSelector = () => setIsPopupDateVisible(false)

  const handleOnClickSendNow = () => {
    const scheduleDate = getCurrentDateAsString()
    const loadingToast = 'Wysyłanie diety ...'
    const successToast = 'Dieta została udostępniona w aplikacji mobilnej'
    realizeOrder(
      orderID,
      selectedFolder,
      selectedDietID,
      scheduleDate,
      loadingToast,
      successToast
    )
      .then((response) => {
        if (response && response.message === 'success') {
          setChangeStatus && setChangeStatus(true)
          handleOnClickClose()
        }
      })
  }

  return (
    <div className={'flex justify-end gap-x-4 mt-4'}>
      <Button
        variant="filled"
        size="medium"
        color="primary"
        type="button"
        onClick={handleOnClickClose}
        className="px-4 py-2 bg-red-500 text-white rounded-md shadow-md hover:bg-red-600 transition-colors"
      >
        Wróć do zamówienia
      </Button>
      {!isStartDietForwarded && (
        <Button
          variant="filled"
          size="medium"
          color="primary"
          type="button"
          onClick={handleOnClickSendNow}
          className="px-4 py-2 bg-green-700 text-white rounded-md shadow-md hover:bg-green-600 transition-colors"
          disabled={
            optionSharingSelected && optionSharingSelected === 'folder'
              ? !selectedFolder
              : !selectedDietID
          }
        >
          Udostępnij dietę w aplikacji mobilnej
        </Button>
      )}

      {isStartDietForwarded && (
        <Button
          variant="filled"
          size="medium"
          color="primary"
          type="button"
          onClick={() => setIsPopupDateVisible(true)}
          className="px-4 py-2 bg-green-700 text-white rounded-md shadow-md hover:bg-green-600 transition-colors"
          disabled={
            optionSharingSelected && optionSharingSelected === 'folder'
              ? !selectedFolder
              : !selectedDietID
          }
        >
          Zaplanuj udostępnienie diety w aplikacji mobilnej
        </Button>
      )}

      <Popup
        isVisible={isPopupDateVisible}
        onClose={handleClosePopupDateSelector}
        size="small"
      >
        <PopupDateSelector
          setSelectedDate={setSelectedDate}
          onCloseClick={handleClosePopupDateSelector}
          startDate={order?.diet_start_date}
        />
      </Popup>
    </div>
  )
}

export default BottomButtons
